import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash.get';
import SimpleRow from '../../../../components/simpleRow/SimpleRow';
import { ICON, PROBE_DETAIL } from '../../../../constants/shared/CommonConstants';
import './SpellingProbeDetails.scss';
import { generateReactKey } from '../../../../utils/shared/commonUtils';

const { CORRECT_RESPONSE } = PROBE_DETAIL;

const SpellingProbeDetails = ({ result, content }) => (
    <div className="container spelling-container">
        <SimpleRow
            columns={[
                <div key="ItemTitle" className="left-margin">
                    Item
                </div>,
                <div key="ResponseTitle" className="left-margin">
                    Response
                </div>,
                <div key="ScoreTitle" className="text-align-center">
                    Score (CSS)
                </div>,
            ]}
            rowClassNames="assessment-row gray-theme"
            cellClassNames="col"
            headerCellsDataTestId="spell-header-cells"
        />

        {result.measureResult.responses.map(({ response, outcome, cssScore, maxCssScore, id }) => (
            <SimpleRow
                key={generateReactKey(id)}
                columns={[
                    <div data-test-id="spell-item" key="item" className="left-margin">
                        {get(content.correctResponses, id, '')}
                    </div>,
                    <span
                        data-test-id="spell-response"
                        key="response"
                        className={`left-margin ${outcome === CORRECT_RESPONSE ? '' : 'red-theme'}`}
                    >
                        {response}
                        {outcome !== CORRECT_RESPONSE && ICON.CLOSE}
                    </span>,
                    <div
                        data-test-id="spell-score"
                        key="score"
                        className="text-align-center"
                    >{`${cssScore}/${maxCssScore}`}</div>,
                ]}
                rowClassNames="assessment-row"
                cellClassNames="col"
            />
        ))}
    </div>
);

SpellingProbeDetails.propTypes = {
    result: PropTypes.object.isRequired,
    content: PropTypes.object.isRequired,
};

export default SpellingProbeDetails;
